var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { singleton } from "tsyringe";
import { IdMap } from "../collections";
import { makeImmutable } from "../core";
import { ProductCategory, ProductCategoryId, } from "../ordering";
import { HalvingPolicyParser } from "./HalvingPolicyParser";
import { VolumeParser } from "./VolumeParser";
let ProductCategoryParser = class ProductCategoryParser {
    constructor(halvingPolicyParser) {
        this.halvingPolicyParser = halvingPolicyParser;
        makeImmutable(this);
    }
    parse(customParameterTypes, modifierTypes, id, category) {
        var _a;
        const categoryVolume = (_a = category.packagingContainersConfig) === null || _a === void 0 ? void 0 : _a.volume;
        return new ProductCategory({
            id: new ProductCategoryId(id),
            divisiblePricePolicy: category.divisiblePricePolicy,
            halvingPolicy: this.halvingPolicyParser.parse(customParameterTypes, category),
            modifierTypes: IdMap.fromIterable(category.categoryModifiers.map((modifierTypeId) => modifierTypes.rawGet(modifierTypeId))),
            volume: categoryVolume ? VolumeParser.parse(categoryVolume) : null,
            ageRestricted: category.ageRestricted,
        });
    }
};
ProductCategoryParser = __decorate([
    singleton(),
    __metadata("design:paramtypes", [typeof (_a = typeof HalvingPolicyParser !== "undefined" && HalvingPolicyParser) === "function" ? _a : Object])
], ProductCategoryParser);
export { ProductCategoryParser };
